module.exports = __webpack_public_path__ + "static/gp-f6877d7ac87b72be1c0547060ceebe2c.svg";